import { z } from 'zod'

export const EstimateItem = z.object({
  name: z.string(),
  net_cents: z.number(),
  billing_freq: z.string().optional()
})

export type EstimateItem = z.infer<typeof EstimateItem>

export const CategoryEstimate = z.object({
  type: z.string(),
  net_cents: z.number(),
  items: EstimateItem.array(),
  is_estimate: z.boolean()
})

export type CategoryEstimate = z.infer<typeof CategoryEstimate>

export const BillingEstimate = z.object({
  period_start: z.number(),
  period_end: z.number(),
  categories: CategoryEstimate.array(),
  net_cents: z.number(),
  vat_cents: z.number(),
  total_cents: z.number(),
  currency: z.string()
})

export type BillingEstimate = z.infer<typeof BillingEstimate>
